import { Visibility, VisibilityOff } from "@mui/icons-material";
import { IconButton, IconButtonProps } from "components_new";
import * as React from "react";

export const VisibilityIconButton: React.FC<{ visible: boolean } & IconButtonProps> = ({ visible, ...props }) => (
  <IconButton color="secondary" sx={{ marginRight: 0.5 }} {...props}>
    {visible ? <Visibility fontSize="small" /> : <VisibilityOff fontSize="small" />}
  </IconButton>
);
